import React from 'react';
import styled from 'styled-components';
import { useField, connect } from 'formik';

import SpaceSelect from '../components/SpaceSelect';
import Error from '../components/Error';
import FieldContextFeeder from '../components/FieldContextFeeder';

const SpaceSelectField = ({ ...props }) => {
  const [field, meta] = useField(props);

  const error = meta.touched && meta.error;
  const { setFieldValue, handleBlur } = props.formik;
  return (
    <Container>
      <SpaceSelect
        {...field}
        {...props}
        meta={meta}
        handleBlur={handleBlur}
        onChange={value => setFieldValue(props.name, value)}
      />
      {error ? <Error>{meta.error}</Error> : null}
    </Container>
  );
};

const Container = styled.div`
  max-width: var(--field-width);
`;

export default FieldContextFeeder(connect(SpaceSelectField));
